import { render, staticRenderFns } from "./TrainingVideo.vue?vue&type=template&id=50df5f3e&"
import script from "./TrainingVideo.vue?vue&type=script&lang=js&"
export * from "./TrainingVideo.vue?vue&type=script&lang=js&"
import style0 from "./TrainingVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports